var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    className: "icon",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M364.032 125.312a293.973 293.973 0 0 1 300.117 2.475c91.478 56.832 147.03 158.293 146.518 267.306-2.134 108.374-61.739 210.304-136.235 289.067a799.019 799.019 0 0 1-143.275 120.32 50.048 50.048 0 0 1-17.408 6.144 34.987 34.987 0 0 1-16.64-5.077A789.973 789.973 0 0 1 290.645 611.54a395.947 395.947 0 0 1-77.312-221.824c-.042-109.312 57.472-210.261 150.699-264.405zm53.845 309.675a101.461 101.461 0 0 0 93.782 63.872 99.797 99.797 0 0 0 71.808-29.91c19.029-19.37 29.696-45.653 29.61-73.088A103.381 103.381 0 0 0 550.7 300.16a100.096 100.096 0 0 0-110.678 22.187 104.747 104.747 0 0 0-22.144 112.64z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M298.667 896a213.333 42.667 0 1 0 426.666 0 213.333 42.667 0 1 0-426.666 0Z",
    opacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.0b4aebd06e21dcf2b56620c70e94209c.svg";
export { ForwardRef as ReactComponent };